import React, { Component } from 'react'
import queryString from 'query-string'
import { 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter, 
  Row, 
  Col, 
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Alert,
  Progress,
} from 'reactstrap'
import { sto } from '../../../config/firebaseconfig'
import uuid from 'uuid/v1'
import firebase from 'firebase'
import saveImageDataToDb from '../../../helpers/content/manageContent/saveImageDataToDb'
import { BeatLoader } from 'react-spinners'
import { ImageGallery } from './'

class ImageManagerModal extends Component {
  constructor(props) {
    super(props)
    this.fileInput = React.createRef()
  }

  state = {
    progress: 0,
    uploading: false,
    error: '',
    success: false,
    activeImage: '',
  }
  
  closeModal = () => {
    const { history, query } = this.props
    let newQuery = {...query}
    delete newQuery.im
    history.push(`?${queryString.stringify(newQuery)}`)
  }

  uploadImage = (e) => {
    e.preventDefault()
    const setState = this.setState.bind(this)
    const file = this.fileInput.current.files[0]
    const ref = sto.ref()
    const ext = this.fileInput.current.files[0].name.substr(-3)
    const id = uuid()
    const path = `images/${id}.${ext}`
    const upload = ref.child(path).put(file)
    if (ext !== 'png' && ext !== 'jpg' && ext !== 'gif') {
      return this.setState({error: 'Must be png, jpg, or gif.', success: false})
    }
    this.setState({uploading: true, error: '', success: false})
    upload.on(firebase.storage.TaskEvent.STATE_CHANGED, 
      function handleProgress(snapshot) {
        setState({progress: snapshot.bytesTransferred / snapshot.totalBytes})
      },
      function handleError(error) {
        setState({uploading: false, progress: 0, error})
      },
      function handleCompletion() {
        upload.snapshot.ref.getDownloadURL().then(url => {
          return saveImageDataToDb(file.name, path, id, ext, url) 
        })
        .then(() => {
          setState({
            progress: 0,
            uploading: false,
            error: '',
            success: true,
          })
        })
        .catch((error) => {
          setState({uploading: false, progress: 0, error})
        })
      }
    )
  }

  selectImage = (id) => this.setState({activeImage: id})
  
  render() {
    const { query, } = this.props
    const { success, error, progress, uploading, activeImage} = this.state
    const { closeModal, uploadImage, fileInput, selectImage} = this
    const progressVal = Math.round(progress * 100)

    return (
      <Modal isOpen={!!query.im} toggle={closeModal} className={'modal-primary'}>
        <ModalHeader toggle={closeModal}>
          Manage/Insert Images
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col xs='12' xl='12'> 
              <Form>
                <FormGroup>
                  <Row>
                    <Col xl='12'>
                      <Label htmlFor='imageUpload'>Upload an Image</Label>
                    </Col>
                    <Col xl='12'>
                      <input 
                        id='imageUpload'
                        name='imageUpload'
                        type='file'
                        ref={fileInput}
                      />
                    </Col>
                    <Col xl='12'>
                      <Button onClick={uploadImage}>
                        {uploading 
                          ? <BeatLoader loading={uploading} /> 
                          : 'Submit'
                        }
                      </Button>
                    </Col>
                  </Row>
                </FormGroup>
              </Form>
            </Col>
            <Col>
              {uploading && 
                <Progress value={progressVal}>
                  {`${progressVal}%`}
                </Progress>
              }
              {success && <Alert>Image uploaded.</Alert>}
              {error && <Alert>Error uploading image.</Alert>}
            </Col>
          </Row>
          <Row><Col>View and select images here</Col></Row>
          <Row>
            <Col>
              <ImageGallery
                activeImage={activeImage}
                selectImage={selectImage}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row><Col><Button onClick={closeModal}>Cancel</Button></Col></Row>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ImageManagerModal


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/ImageManagerModal.js